export const gaseosasProducts = [
  // CCU - Latas 350 ml
  {
    id: 301,
    name: 'Canada Dry lata 350 ml',
    image:
      'https://public.readdy.ai/ai/img_res/bb45731f-484c-46dc-942f-1117a3f8c9c7.png',
    unitsPerPack: 6,
    packagingType: 'Display',
    unitPrice: 585,
    packPrice: 3510,
    palletPrice: 570,
  },
  {
    id: 302,
    name: 'Bilz lata 350 ml',
    image:
      'https://public.readdy.ai/ai/img_res/bec1ccda-f7d9-4a90-8d23-5d7af4f12b6c.png',
    unitsPerPack: 6,
    packagingType: 'Display',
    unitPrice: 585,
    packPrice: 3510,
    palletPrice: 570,
  },
  {
    id: 303,
    name: 'Pap lata 350 ml',
    image:
      'https://public.readdy.ai/ai/img_res/48c2274d-8ff3-413f-be74-04e54b978f2f.png',
    unitsPerPack: 6,
    packagingType: 'Display',
    unitPrice: 585,
    packPrice: 3510,
    palletPrice: 570,
  },
  {
    id: 304,
    name: 'Pepsi lata 350 ml',
    image:
      'https://public.readdy.ai/ai/img_res/e601d616-1d69-42fb-a42c-84fb7639d848.png',
    unitsPerPack: 6,
    packagingType: 'Display',
    unitPrice: 585,
    packPrice: 3510,
    palletPrice: 570,
  },
  {
    id: 305,
    name: 'Pepsi Zero lata 350 ml',
    image:
      'https://public.readdy.ai/ai/img_res/db9e3180-3d1a-4e5b-9677-5f9d1efde425.png',
    unitsPerPack: 6,
    packagingType: 'Display',
    unitPrice: 585,
    packPrice: 3510,
    palletPrice: 570,
  },
  {
    id: 306,
    name: 'Kem Piña lata 350 ml',
    image:
      'https://public.readdy.ai/ai/img_res/551a3bb6-2eb1-41c5-adf1-0e16ffe9c87f.png',
    unitsPerPack: 6,
    packagingType: 'Display',
    unitPrice: 585,
    packPrice: 3510,
    palletPrice: 570,
  },
  {
    id: 307,
    name: 'Limón Soda lata 350 ml',
    image:
      'https://public.readdy.ai/ai/img_res/b5a2b44b-8c23-419c-a6b7-0cdafc0b412e.png',
    unitsPerPack: 6,
    packagingType: 'Display',
    unitPrice: 585,
    packPrice: 3510,
    palletPrice: 570,
  },
  // Coca-Cola Company - Latas 350 ml
  {
    id: 308,
    name: 'Coca Cola lata 350 ml',
    image:
      'https://public.readdy.ai/ai/img_res/77c5ff59-c4cf-4b71-ba6d-5a69a0ac3f4d.png',
    unitsPerPack: 6,
    packagingType: 'Display',
    unitPrice: 780,
    packPrice: 4680,
    palletPrice: 760,
  },
  {
    id: 309,
    name: 'Coca Cola Zero lata 350 ml',
    image:
      'https://public.readdy.ai/ai/img_res/b6d68644-4770-4439-9743-adaf70d8fda6.png',
    unitsPerPack: 6,
    packagingType: 'Display',
    unitPrice: 780,
    packPrice: 4680,
    palletPrice: 760,
  },
  {
    id: 310,
    name: 'Sprite lata 350 ml',
    image:
      'https://public.readdy.ai/ai/img_res/5972e12a-d3f8-46c4-b91b-790f2174c68e.png',
    unitsPerPack: 6,
    packagingType: 'Display',
    unitPrice: 780,
    packPrice: 4680,
    palletPrice: 760,
  },
  // CCU - Botella 3 L
  {
    id: 311,
    name: 'Canada Dry 3 L',
    image:
      'https://public.readdy.ai/ai/img_res/88c0a60b-b174-4055-a5ba-42c3b6e95da9.png',
    unitsPerPack: 6,
    packagingType: 'Display',
    unitPrice: 1990,
    packPrice: 10500,
    palletPrice: 1945,
  },
  {
    id: 312,
    name: 'Bilz 3 L',
    image:
      'https://public.readdy.ai/ai/img_res/0e6bc977-e6c7-460f-9601-beae8d081427.png',
    unitsPerPack: 6,
    packagingType: 'Display',
    unitPrice: 1990,
    packPrice: 10500,
    palletPrice: 1945,
  },
  {
    id: 313,
    name: 'Pap 3 L',
    image:
      'https://public.readdy.ai/ai/img_res/88dfd02b-994d-4eb4-a53f-b6cc4e6b1ed3.png',
    unitsPerPack: 6,
    packagingType: 'Display',
    unitPrice: 1990,
    packPrice: 10500,
    palletPrice: 1945,
  },
  {
    id: 314,
    name: 'Pepsi 3 L',
    image:
      'https://public.readdy.ai/ai/img_res/a5384124-3c23-45d8-926b-65df8bd9faf0.png',
    unitsPerPack: 6,
    packagingType: 'Display',
    unitPrice: 1990,
    packPrice: 10500,
    palletPrice: 1945,
  },
  {
    id: 315,
    name: 'Pepsi Zero 3 L',
    image:
      'https://public.readdy.ai/ai/img_res/73613ee8-ce5d-4f66-8fc0-ecc1501aef25.png',
    unitsPerPack: 6,
    packagingType: 'Display',
    unitPrice: 1990,
    packPrice: 10500,
    palletPrice: 1945,
  },
  {
    id: 316,
    name: 'Kem Piña 3 L',
    image:
      'https://public.readdy.ai/ai/img_res/4261a933-263f-4728-b864-1f030593186e.png',
    unitsPerPack: 6,
    packagingType: 'Display',
    unitPrice: 1990,
    packPrice: 10500,
    palletPrice: 1945,
  },
  {
    id: 317,
    name: 'Limón Soda 3 L',
    image:
      'https://public.readdy.ai/ai/img_res/03bbc9b5-bce3-4543-a729-da0b75c02931.png',
    unitsPerPack: 6,
    packagingType: 'Display',
    unitPrice: 1990,
    packPrice: 10500,
    palletPrice: 1945,
  },
  // Coca-Cola Company - Botella 1.5 L
  {
    id: 318,
    name: 'Coca Cola 1.5 L',
    image:
      'https://public.readdy.ai/ai/img_res/96aca7d9-2255-478d-ba04-9d6b99f8a1b8.png',
    unitsPerPack: 6,
    packagingType: 'Display',
    unitPrice: 1600,
    packPrice: 9600,
    palletPrice: 1580,
  },
  {
    id: 319,
    name: 'Coca Cola Zero 1.5 L',
    image:
      'https://public.readdy.ai/ai/img_res/315dcb10-6bc2-4717-985d-1a042d378dbd.png',
    unitsPerPack: 6,
    packagingType: 'Display',
    unitPrice: 1600,
    packPrice: 9600,
    palletPrice: 1580,
  },
  {
    id: 320,
    name: 'Sprite 1.5 L',
    image:
      'https://public.readdy.ai/ai/img_res/b7408c44-ef0d-4780-8441-0933ed00619a.png',
    unitsPerPack: 6,
    packagingType: 'Display',
    unitPrice: 1600,
    packPrice: 9600,
    palletPrice: 1580,
  },
  // Piri - Botella 3 L
  {
    id: 321,
    name: 'Piri Naranja 3 L',
    image:
      'https://public.readdy.ai/ai/img_res/ec9dfb1b-f796-4d97-b2e4-6a69ecb3f83e.png',
    unitsPerPack: 6,
    packagingType: 'Display',
    unitPrice: 900,
    packPrice: 5400,
    palletPrice: 885,
  },
  {
    id: 322,
    name: 'Piri Guaraná 3 L',
    image:
      'https://public.readdy.ai/ai/img_res/6c641767-a8a2-4185-b457-5d14798a1723.png',
    unitsPerPack: 6,
    packagingType: 'Display',
    unitPrice: 900,
    packPrice: 5400,
    palletPrice: 885,
  },
  {
    id: 323,
    name: 'Piri Ginger Ale 3 L',
    image:
      'https://public.readdy.ai/ai/img_res/d7199c22-1e6e-4924-976e-f19211c37c8b.png',
    unitsPerPack: 6,
    packagingType: 'Display',
    unitPrice: 900,
    packPrice: 5400,
    palletPrice: 885,
  },
  {
    id: 324,
    name: 'Coca Cola 2.5 L',
    image:
      'https://public.readdy.ai/ai/img_res/d6f7e9e8-5e07-4759-a43d-c1dcb599cbcd.png',
    unitsPerPack: 6,
    packagingType: 'Display',
    unitPrice: 2200,
    packPrice: 13200,
    palletPrice: 2180,
  },
  {
    id: 325,
    name: 'Coca Cola Zero 2.5 Lt ',
    image:
      'https://public.readdy.ai/ai/img_res/23b99684-00ea-426a-8426-e0609e8f2f1d.png',
    unitsPerPack: 6,
    packagingType: 'Display',
    unitPrice: 2200,
    packPrice: 13200,
    palletPrice: 2180,
  },
  {
    id: 326,
    name: 'Sprite 2.5 Lt',
    image:
      'https://public.readdy.ai/ai/img_res/591aa359-ca99-41c4-a184-52ca06543e93.png',
    unitsPerPack: 6,
    packagingType: 'Display',
    unitPrice: 2200,
    packPrice: 13200,
    palletPrice: 2180,
  },
  {
    id: 327,
    name: 'Piri Ginger Ale 3 L',
    image:
      'https://public.readdy.ai/ai/img_res/01785b59-b2dc-4fa6-ae57-9cf0f4e62269.png',
    unitsPerPack: 6,
    packagingType: 'Display',
    unitPrice: 900,
    packPrice: 5400,
    palletPrice: 885,
  },
  {
    id: 328,
    name: 'Piri Cola 3 L',
    image:
      'https://public.readdy.ai/ai/img_res/99647686-55f4-4f0a-9ea6-33a54d1cfebb.png',
    unitsPerPack: 6,
    packagingType: 'Display',
    unitPrice: 900,
    packPrice: 5400,
    palletPrice: 885,
  },
];
